<template>
    <div>
        <b-modal 
            ref="historyModal" 
            :title="historyTitle" 
            :ok-only="true"
            :ok-variant="'secondary'"
            :ok-title="$t('misc.cancel')"
			size="huge"
            @hidden="hidden"
        >
            <data-table
                v-if="tableLoaded"
                :search="search"
                :exportable="false"
                :importable="false"
                title=""
                :rows="getData.rowData"
                :columns="columnData"
                :perPage="perPage"
                :rowsCount="rowsCount"
                :currentPage="currentPage"
                :pageCount="pageCount"
                @changePage="changePage"
            >
            </data-table>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';

export default {
    name: 'isometric_management_parts_history',
    components: {
        DataTable,
        notificationIcons,
    },
    props: {
        section: {
            type: String,
            required: true,
        },
        search: {
            type: Boolean,
            defaukt: false,
        },
    },
    data() {
        return {
            historyTitle: Vue.i18n.translate('modal.general.iso_parts_revision_history'),
            row: null,

            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,

            getData: {
                rowData: [],
            },
            columnData: [
                {
                    label: Vue.i18n.translate('table.old_total_quantity'),
                    field: 'old_total_quantity',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.isometric_revision_date'),
                    field: 'isometric_revision_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.isometric_revision_number'),
                    field: 'isometric_revision_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_number'),
                    field: 'number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_description'),
                    field: 'description',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_material'),
                    field: 'material',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_size'),
                    field: 'size',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thk'),
                    field: 'thk',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_sizer'),
                    field: 'sizer',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_thkr'),
                    field: 'thkr',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.part_dimension'),
                    field: 'dimension',
                    numeric: false,
                    html: false,
                },
            ]
        }
    },
    mounted () {
    },
    methods: {
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = null;
            switch (this.section) {
                case 'parts':
                    data = http.route('drawing_part/' + this.row.id + '/get_part_history?page=' + this.currentPage).get();
                break;
                case 'isometrics':
                    data = http.route('drawing_part/isometric?drawing_id=' + this.row.id + '&filters[parent_drawing_id]=' + this.row.id + '&page=' + this.currentPage).get();
                break;
            }

            if (data != null) {
                data.then(response => {
                    if (!response.isError) {
                        this.perPage     = response.pagination.limit;
                        this.rowsCount   = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount   = response.pagination.totalPages;
                        this.getData.rowData = response.data;
                        this.tableLoaded     = true;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        showModal(row) {
            this.row = row;
            this.onLoadTable();
            this.$refs.historyModal.show();
        },
        hidden () {
            this.row = null;
            this.rowData = [];
            this.tableLoaded = false;
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/project/isometric_management/isometric_management_parts_history.vue